import CheckFeature from '../checkfeature'
import { Team } from '@/modules/teams/classes'

export default class SkipSelftest extends CheckFeature {
  hasFeature (): boolean {
    return this.currentTeam?.features?.skipSelftest?.enabled ?? false
  }

  override get description (): string {
    return 'Allows skipping the selftest when selftest is failing'
  }

  teamHasFeature (teamId: string): boolean {
    const team = this.teams[teamId]
    return team?.features?.skipSelftest?.enabled ?? false
  }

  assignTeamFeature (team: Partial<Team>, enabled: boolean): void {
    team.features = team.features ?? {}
    team.features.skipSelftest = { enabled }
  }

  isGlobalFeature (): boolean {
    return false
  }
}
